<template>
    <div class="an-ken-cl" v-if="isNotLogin">
        <title-screen title ="8"></title-screen>
        <div id="ankenList"></div>
        <anken-info v-loading="ankenLoading"
                    element-loading-text="Loading..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.5)"
                    v-bind:is-anken="true"
                    @ankenInfoLoad="ankenInfoLoad"
                    @showExplanation="handleShowExplanation"
        ></anken-info>
        <div id="explanation" v-show="isMobile">
            <br><h1 style="color:#a5272a;float: left">機能説明</h1><br>
            <br><span>ご依頼内容で利用できる各機能の説明は以下の通りです。</span><br>
            <li>
                <a class="button-hide-show" id="button-hide-box-search" @click="handleHideExplanation" v-show="isShowExplanation" >
                    -
                </a>
                <a class="button-hide-show" id="button-show-box-search" style="display:none" @click="handleShowExplanation" v-show="isHideExplanation">
                    +
                </a>
            </li><br>
            <div class="info pb-10px pt-10px" v-show="isShowExplanation">
                <h1 style="color:#a5272a">相続手続きチェックリスト</h1>
                <p>相続の際に必要となる手続きを一覧にまとめました。</p><br>
                <h1 style="color:#a5272a">スマホで書類提供</h1>
                <p>スマートフォンから相続手続きで必要な書類をアップロードできます。</p><br>
                <h1 style="color:#a5272a">報告書</h1>
                <p>ご契約についての報告書をご確認いただけます。</p><br>
                <h1 style="color:#a5272a">遺産分割シミュレーション</h1>
                <p>実際の遺産価額から遺産分割のシミュレーションができます。</p><br>
                <h1 style="color:#a5272a">レガシィほっとライン</h1>
                <p>税理士法人レガシィの担当者とチャットができます。</p>
            </div>
            <li><a href="#ankenList" style="color:#3a8ee6;float: left" >ご依頼一覧に戻る場合はコチラ</a></li>
        </div>
    </div>
    <div class="an-ken-cl" v-else></div>
</template>
<script>
import TitleScreen from '@/components/common/TitleScreen'
import AnkenInfo from './AnkenInfo'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'
export default {
  data () {
      return {
          ankenLoading: true,
          isNotLogin: false,
          isMobile: isMobile,
          isHideExplanation: false,
          isShowExplanation: true
      }
  },
  components: {
    AnkenInfo,
    'title-screen': TitleScreen
  },
  computed: {
      ...mapGetters(['currentUser', 'isAuthenticated'])
  },
  methods: {
      fetchData () {
          let memberId = this.currentUser.id === undefined ? '' : this.currentUser.id
          if (parseInt(memberId) > 0) {
              this.isNotLogin = true
          } else {
              this.$alert('この機能を使うにはまずはお問い合わせください', '', {
                  confirmButtonText: 'OK'
              })
          }
      },
      ankenInfoLoad (val) {
          this.ankenLoading = !val
      },
      handleHideExplanation () {
        this.isHideExplanation = true
        this.isShowExplanation = false
      },
      handleShowExplanation () {
        this.isHideExplanation = false
        this.isShowExplanation = true
      }
  },
  created () {
      this.fetchData()
      this.$bus.$on('refreshData', (data) => {
          if (this.$route.name === data) {
              this.fetchData()
          }
      })
  }
}
</script>
<style scoped>
    @import "../portal/portal.css";
    @import "../../../../assets/css/client_custom.css";
    .button-hide-show {
        float: right !important;
        width: 15px !important;
        height: 15px !important;
        background: black;
        color: white !important;
        text-align: center;
        line-height: 13px;
    }
</style>
